'use strict';

const CommandCheckboxDirective=require('../../../../../../dist-es6/client/directives/commandCheckboxDirective/commandCheckboxDirective');let

ToggleNotificationsCheckboxDirective=class ToggleNotificationsCheckboxDirective extends CommandCheckboxDirective{
get templateUrl(){
return'/templates/features/notificationSettings/components/groupNotificationSettingsDirective/toggleNotificationsCheckboxTemplate';
}};


module.exports=ToggleNotificationsCheckboxDirective;
//# sourceMappingURL=toggleNotificationsCheckboxDirective.js.map
